import React from 'react';
import Hero from './Hero';
import { useParams } from 'react-router-dom';
import { useAppState } from '../context/State';
import BrandBody from './BrandBody';

const BrandPage = () => {
  const state = useAppState();
  const adData = state.adData;
  const videoData = state.videoData;
  const { brand } = useParams();
  const modifiedStr = brand.toLowerCase().trim().replace(/ /g, '-');
  const dataToFilter = state.activeOption === 'Video' ? videoData : adData;
  let brandData = dataToFilter.find(
    (brand) => brand.name.toLowerCase().trim().replace(/ /g, '-') === modifiedStr
  );
  
  if (brandData === undefined) {
    state.setActiveOption('Video');
    return 'sorry, brand not found';
  }

  brandData = {
    name: brandData.name,
    ...Object.fromEntries(
      brandData.custom_fields.map(f => {
        if (f.type === 'drop_down' && typeof f.value === 'number' && Array.isArray(f.type_config?.options)) {
          const option = f.type_config.options[f.value];
          return [f.name, option?.name || f.value]; // fallback to raw value if not found
        }
        return [f.name, f.value];
      })
    )
  };

  return (brandData && <BrandBody brandData={brandData} />) || 'sorry, brand not found';
};

export default BrandPage;
